import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useFetch, useApiClient } from '@marageti/z4-lib';
import { Review, ReviewStatus } from '@marageti/z4-sdk/lib/travel';
import TripReviewStepperForm from '../../components/trip-review-stepper-form';
import { useAuthStore } from '../../store';

const TripReviewContainer = () => {
  const apiClient = useApiClient();
  const { tripMatchId } = useParams<{ tripMatchId: string }>();
  const { loggedInTraveler } = useAuthStore();
  const navigate = useNavigate();

  const { data: tripMatchReviews } = useFetch<Review[]>(
    apiClient.tripMatchesClient.getTripMatchReviews,
    [tripMatchId],
    !!tripMatchId,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  useEffect(() => {
    if (tripMatchReviews) {
      const ownedReview = tripMatchReviews.find((review) => review.travelerId === loggedInTraveler?.id);
      if (ownedReview) {
        if (ownedReview.status === ReviewStatus.ReviewStatusCompleted) {
          navigate(`/reviews/${ownedReview.id}`, { replace: true });
        } else {
          navigate(`/trip-matches/${tripMatchId}/review/${ownedReview.id}`, { replace: true });
        }
      }
    }
  }, [tripMatchReviews]);

  return (
    <TripReviewStepperForm
      tripMatchId={tripMatchId}
      reviewId={undefined}
    />
  );
};

export default TripReviewContainer;
